// async getSupervisorWorkers({}, { supervisor }) {
//   const query = { managerId: supervisor };
//   const { data } = await supervisionClient.getWorkers(query);
//   return data;
// },

export const USERS_REQUEST = "USERS_REQUEST";
const _USERS_SUCCESS = "USERS_SUCCESS";
const _USERS_ERROR = "USERS_ERROR";

const _SUPERVISORS_REQUEST = "SUPERVISORS_REQUEST";
const _SUPERVISORS_SUCCESS = "SUPERVISORS_SUCCESS";
const _SUPERVISORS_ERROR = "SUPERVISORS_ERROR";

export const TEAMS_REQUEST = "TEAMS_REQUEST";
const _TEAMS_SUCCESS = "TEAMS_SUCCESS";
const _TEAMS_ERROR = "TEAMS_ERROR";

export const REPORTS_INDICATION = "REPORTS_INDICATION";
